import { ContactDetail, CustomAddress } from "@/explore/types";
import { DeliveryIndicator } from "./builders/ffl-get-transformer.mjs";
import ContactInfo from "./contact-info.mjs";
import GeoData from "./geo-data.mjs";

interface LicenseeBase {
  id: string;
}

export default interface Licensee extends LicenseeBase {
  /**
   * The name of the licensee
   */
  name: string;

  /**
   * The full licensee key
   */
  licenseId?: string;
  fullLicenseKey?: string | null;
  /**
   * The licensee's contact
   */
  contact: ContactInfo;

  /**
   * The licensee's geolocation
   */
  geo?: GeoData;

  /**
   * URL of the current license proof
   */
  licenseProof?: string;

  /**
   * URL of the FFL ez-check proof
   */
  ezCheckProof?: string;

  /**
   * Social place details
   */
  placeDetails?: PlaceDetails;

  /**
   * The customer ratings for the licensee
   */
  socialRating?: {
    count: number;
    score: number;
  };

  /**
   * What transfer feees?
   */
  transferFees?: TransferFees;

  /**
   * What transfers are accepted?
   */
  transfersAccepted?: TransfersAccepted;

  /**
   * The type of business, e.g. Shooting range or Gun store
   */
  businessType?: string | null;

  /**
   * The number of transfers through MasterFFL
   */
  totalTransfersCount?: number;
  storeTransfersCount?: number;
  pendingTransfersCount?: number;

  optOutOptions?: string;

  /**
   * License expiry date
   */
  expiry?: string
  dealer_id?: string
  // License Name
  licenseName?: string;
  has_verified_certificate?: boolean;
  license_key: string;
  contactNames: Array<string>;
  websiteUrls: Array<string>;
  deliveryIndicator: DeliveryIndicator | null;
  transferFeesStatus: TransferFeesStatus;
  licenseType: string;
  isDealerOptOut: boolean;
  contactPhones: string[];
  hasLicenseHistory?: boolean;
  licensedetails: {
    positionTitle: string;
    printedName: string;
    printedDate: string;
  } | null;
  industryRelevance: number;
  contactDetails?: Array<ContactDetail>;
  isPreferred:boolean;
  isStockingDealer: boolean;
  isRange: boolean;
  isBlacklisted:boolean;
  customAddress?: Array<CustomAddress>;
  defaultShippingAddress?: DefaultShippingAddress;
  licenseExpiry?: string;
  isExternal: boolean;
  ezCheckDetails: {
    status: string,
    created_at: string
  } | null
}

export interface PlaceDetails {
  facebook: PlaceDetailBase;
  linkedin: PlaceDetailBase;
  google: GooglePlaceDetails;
  yelp: PlaceDetailBase;
}

export interface PlaceDetailBase {
  profile_url: string;
  user_rating_count: string;
  user_rating_average: string;
}
export interface GooglePlaceDetails {
  id: string;
  name: string;
  photos: LicenseePhoto[];
  website: string;
  location: {
    lat: number;
    lng: number;
  }
  profile_url: string;
  business_status: string;
  user_rating_count: number; // integer
  address_components: {
    route: string;
    country: string;
    locality: string;
    political: string;
    subpremise: string;
    postal_code: string;
    neighborhood: string;
    street_number: string;
    administrative_area_level_1: string;
    administrative_area_level_2: string;
  },
  hours_of_operation: HoursOfOperation,
  user_rating_average: number;
}

interface yelpInfo {
  rating: string;
  reviewsCount: string;
}

interface LicenseePhoto {
  width: number;
  height: number;
  photo_reference: string;
}

export interface HoursOfOperation {
  periods: HoursOfOperationPeriod[];
  weekday_text: string[];
}

interface HoursOfOperationPeriod {
  open: {
    day: number; // integer
    time: string; // 24-hour time
  },
  close: {
    day: number; // integer
    time: string; // 24-hour time
  }
}

export interface TransferFees {
  nicsFee: number | null,
  nfaFee: number | null,
  pistolFee: number | null,
  rifleFee: number | null,
  shotgunFee: number | null,
  sbrFee: number | null,
  suppressorFee: number | null,
  discountMultipleFirearms: number | null,
  receiverFee: number | null,
}

export interface TransfersAccepted {
  pistol: boolean;
  rifle: boolean;
  sbr: boolean;
  suppressor: boolean;
  machinegun: boolean;
  destructiveDevice: boolean;
  aow: boolean;
  shotgun: boolean;
}

export interface OptOutOptions {
  thisStore: boolean;
  allStores: boolean;
}

export interface TransferFeesStatus {
  pistol_enabled: boolean | undefined;
  rifle_enabled: boolean | undefined;
  sbr_enabled: boolean | undefined;
}

export enum SHIPPING_ADDRESS_TYPE {
  PREMISE="PREMISE",
  MAILING="MAILING",
  CUSTOM="CUSTOM"
}

export interface DefaultShippingAddress { type: SHIPPING_ADDRESS_TYPE, id?: string }
